export default __webpack_public_path__ + "static/media/key.d2961678.svg";